import React from 'react';
import SVGTrash from '../../svg/Trash.js';
import Formsy from 'formsy-react';
import FormSelect from '../form/Select';
import { Link } from 'react-router-dom';
import { adminClientName } from '../../masks.js';
import { adminMenuSelectionSwitch } from '../../helpers/switches';

class ServiceClient extends React.Component {
  render() {
    return (
      <div className="cms__section">
        <div className="cms__bar cms__section-head">
          <div className="cms__bar-left">
            <h3 className="h3">Client</h3>
          </div>
          <div className="cms__bar-right">
            {this.renderEditButton()}
            {this.renderSaveButton()}
          </div>
        </div>
        <div className="cms__section-body">
          {this.renderClientHeader()}
          {this.renderClientView()}
          {this.renderClientEdit()}
          {this.renderClientSelection()}
          {this.renderAddButton()}
        </div>
      </div>
    );
  }

  renderEditButton = () => {
    if (!this.props.isEdit && this.props.client)
      return (
        <span className="a--blue" onClick={this.openEdit}>
          Edit
        </span>
      );
  };

  renderSaveButton = () => {
    if (this.props.isEdit && this.props.client)
      return (
        <span className="a--blue" onClick={this.closeEdit}>
          Preview
        </span>
      );
  };

  renderAddButton = () => {
    if (!this.props.client)
      return (
        <div
          className="btn btn--white btn--full-width"
          onClick={this.props.openModal}
        >
          + Add Client
        </div>
      );
  };

  renderClientHeader = () => {
    if (this.props.client)
      return (
        <div className="row row--nowrap row--space-between row--pad row--border-bottom">
          <div className="p row__item row__item--fifth p--bold">Name</div>
          <div className="p row__item row__item--fifth p--bold">
            Service Address
          </div>
          <div className="p row__item row__item--sixth p--bold">
            Phone Number
          </div>
          <div className="p row__item row__item--fourth p--bold">Email</div>
          <div className="p row__item row__item--sixth p--bold">Allergens</div>
          <div className="p row__item row__item--twentieth p--bold"> </div>
        </div>
      );
  };

  renderClientAllergens = (client) => {
    const { allergen_tags, other_allergens } = client;
    const allergies = allergen_tags.map(tag => tag.tag)
    if (other_allergens) allergies.push(other_allergens)
    return (allergies.map(allergy => (
      <div key={allergy} className="--capitalize">{allergy.toLowerCase()}</div>
    )))
  }

  renderClientView = () => {
    const { address, client } = this.props;
    if (!this.props.isEdit && client) {
      const { id, phone_number, email } = client;
      return (
        <div className="row row--nowrap row--space-between row--pad">
          <div className="row__item row__item--fifth">
            <Link
              className="a--black"
              target="_blank"
              to={`/admin/client/${id}`}
            >
              {adminClientName(client)}
            </Link>
          </div>
          <div className="p p--truncate row__item row__item--fifth">
            {address && 'street_address' in address
              ? `${address.street_address}`
              : ''}
            {address && 'zip_code' in address ? `, ${address.zip_code}` : ''}
          </div>
          <div className="p p--truncate row__item row__item--sixth">
            {phone_number || ''}
          </div>
          <div className="p p--truncate row__item row__item--fourth">
            {email || ''}
          </div>
          <div className="p p--truncate row__item row__item--sixth">
            {this.renderClientAllergens(client)}
          </div>
          <div className="p p--truncate row__item row__item--twentieth"> </div>
        </div>
      );
    }
  };

  renderClientEdit = () => {
    const { address, client } = this.props;
    const { handleSelectChange } = this;
    if (this.props.isEdit && client) {
      const { phone_number, email } = this.props.client;
      const client_addresses = client.service_addresses.map(
        ({ id, street_address, label }) => ({
          value: id,
          label: `${label} - ${street_address}`
        })
      );

      return (
        <Formsy className="form">
          <div className="p row row--nowrap row--space-between row--bordered">
            <div className="p--truncate row--bordered__item row__item--fifth">
              {this.props.client && adminClientName(this.props.client)}
            </div>
            <div className="row--bordered__item row__item--fifth">
              <FormSelect
                name="address"
                placeholder="Address"
                value={address.id}
                onChange={handleSelectChange}
                options={client_addresses}
                required
              />
            </div>
            <div className="p--truncate row--bordered__item row__item--sixth">
              {phone_number || ''}
            </div>
            <div className="p--truncate row--bordered__item row__item--fourth">
              {email || ''}
            </div>
            <div className="p--truncate row--bordered__item row__item--sixth">
              {this.renderClientAllergens(client)}
            </div>
            <div className="row--bordered__item row__item--twentieth">
              <span
                className="btn-icon btn-icon--trash"
                onClick={this.deleteClient}
              >
                <SVGTrash />
              </span>
            </div>
          </div>
        </Formsy>
      );
    }
  };

  renderClientSelection() {
    if (this.props.client)
      return (
        <p className="p p--dark-taupe p--pad-top">
          {adminMenuSelectionSwitch(this.props.client.menu_selection_status)}
        </p>
      );
  }

  openEdit = () => {
    this.props.updateService({}, { isClientEdit: true });
  };

  closeEdit = () => {
    this.props.updateService({}, { isClientEdit: false });
  };

  handleSelectChange = val => {
    if (val) {
      const selected_address = this.props.client.service_addresses.find(
        address => address.id === val.value
      );
      this.props.updateService({ address: { ...selected_address } });
    }
  };

  deleteClient = () => {
    this.props.updateService({ client: null, address: null });
  };
}

export default ServiceClient;



// WEBPACK FOOTER //
// ./src/components/service/ServiceClient.js